import { BottomSheetModal } from '@gorhom/bottom-sheet';
import { Href, useRouter } from 'expo-router';
import React, { RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import BottomSheet from 'shared/components/vxl/BottomSheet/BottomSheet';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import ListItem from 'shared/components/vxl/ListItem/ListItem';
import theme from 'shared/styles/theme';

const Separator = () => {
  return (
    <View style={styles.dividerWrapper}>
      <HairLineDivider />
    </View>
  );
};

interface TransferHistoryBottomSheetProps {
  bottomSheetRef: RefObject<BottomSheetModal | null> | null;
}

const TransferHistoryBottomSheet = ({
  bottomSheetRef,
}: TransferHistoryBottomSheetProps) => {
  const router = useRouter();
  const { t: translatedText } = useTranslation('moveMoney', {
    keyPrefix: 'transactionHistoryBottomSheet',
  });

  const handlePress = (url: Href) => {
    router.push(url);
    bottomSheetRef?.current?.dismiss();
  };

  return (
    <BottomSheet
      ref={bottomSheetRef}
      contentContainerStyle={styles.bottomSheetContainer}
    >
      <View testID="transfer-history-bottom-sheet">
        <ListItem
          onPress={() => handlePress('/move-money/transfer/transfer-history')}
          primaryCopy={translatedText('history')}
          analyticsId="transfer_history"
        />
        <Separator />
        <ListItem
          onPress={() => handlePress('/move-money/check-deposit-history')}
          primaryCopy={translatedText('mobileDeposit')}
          analyticsId="mobile_deposit_history"
        />
        <Separator />
        <ListItem
          onPress={() => handlePress('/move-money/v2a/transfer-history')}
          primaryCopy={translatedText('v2a')}
          analyticsId="v2a_transfer_history"
        />
      </View>
    </BottomSheet>
  );
};

const styles = StyleSheet.create({
  bottomSheetContainer: {
    paddingTop: 0,
  },
  dividerWrapper: {
    paddingHorizontal: theme.spacing.m,
  },
});

export default TransferHistoryBottomSheet;
